import React, { createContext, useContext, useState } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  // Initialize cart from localStorage if available
  const [cart, setCart] = useState(() => {
    try {
      const stored = window.localStorage.getItem('enquiry_cart');
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  });

  const addToCart = (product) => {
    setCart((prev) => {
      // Check if product already exists in cart
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        // Update quantity for existing product
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + (product.quantity || 1) }
            : item
        );
      }
      // Add new product
      return [...prev, { ...product, quantity: product.quantity || 1 }];
    });
  };

  // Persist cart to localStorage on change
  React.useEffect(() => {
    window.localStorage.setItem('enquiry_cart', JSON.stringify(cart));
  }, [cart]);


  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  const clearCart = () => setCart([]);

  // Update quantity for a cart item
  const updateQuantity = (id, delta) => {
    setCart((prev) => {
      return prev
        .map((item) =>
          item.id === id
            ? { ...item, quantity: Math.max(1, item.quantity + delta) }
            : item
        )
        .filter((item) => item.quantity > 0); // Remove if quantity is 0
    });
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, updateQuantity }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
